import { gql, useMutation } from '@apollo/client'

import agentClient from '@/lib/apollo/client/agent'
import type { WrappedMutation } from '@/lib/apollo/types'

const cancelOpenBankingRequestMutation = gql`
  mutation cancelOpenBankingRequest(
    $customerId: String!
    $applicationId: String!
    $subjectId: String!
    $recommendationId: String!
    $notifyApplicant: Boolean!
  ) {
    cancelOpenBankingRequest(
      customerId: $customerId
      applicationId: $applicationId
      subjectId: $subjectId
      recommendationId: $recommendationId
      notifyApplicant: $notifyApplicant
    )
  }
`

export type MutationVars = {
  customerId: string
  applicationId: string
  subjectId: string
  recommendationId: string
  notifyApplicant: boolean
}

export type CancelOpenBankingRequestData = {
  cancelOpenBankingRequestData: string | unknown
}

export const useCancelOpenBankingRequestMutation: WrappedMutation<
  CancelOpenBankingRequestData,
  MutationVars
> = () =>
  useMutation<CancelOpenBankingRequestData, MutationVars>(
    cancelOpenBankingRequestMutation,
    {
      client: agentClient,
    },
  )
